module.exports = __webpack_public_path__ + "static/media/bell.c3233122.svg";